<template>
  <GMapMap
      ref="mapRef"
      :center="center"
      :zoom="15"
      :min-zoom="5"
      :max-zoom="15"
      map-type-id="terrain"
      style="width: 100vw; height: 20rem;"
  >
    <GMapCluster :zoomOnClick="true">
      <GMapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @click="center = m.position"
      />
    </GMapCluster>
  </GMapMap>
</template>

<script>
export default {
  data() {
    return {
      center: { lat: -12.046374026071097, lng: -77.04276187021284 },
      markers: [
        {
          position: {
            lat: -12.046374026071097,
            lng: -77.04276187021284,
          },
        },
      ],
    };
  },
  methods:{
    infoClicked(context) {
      // console.log(center)
      console.log(context)
      console.log("ok")
    }
  }
};
</script>

<style>
body {
  margin: 0;
}
  .vue-map-change{
    min-height: 20rem !important;
  }
</style>
